export default function AboutMe() {
    return (
        <div
            className="about-me-container parent"
        >
            <div style={{ paddingBottom: "5px" }}>
                My name is Ardian Kovanxhi. I'm born and raised in New Jersey, just outside of NYC.
            </div>
            As early as I could remember, I was in love with all things technology - gaming, building and taking apart computers, and coding.
            School was a bore but technology was always fun. I couldn't wait to come home and work on my projects. That is where I found my passion, which turned into a full time job.
            It all started with my first computer build, which turned into building computers for my friends and classmates, which quickly spun into a network of referrals and renewals.
            I have been self employed + freelancing since 2019 - but now I am seeking a full time full stack dev position in order to become part of a team and grow something together.

            <div style={{ paddingTop: "5px" }}>
                <a href="mailto:akovanxhi@gmail.com">
                    akovanxhi@gmail.com
                </a>

                <div>
                    201-851-2283
                </div>

            </div>

        </div>
    )
}